import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { companyService } from "services/Services";
import { Activeproduct } from "models/Company";
import { UrlPath } from "utility/routes";
import LoadingScreen from "components/LoadingScreen";
import { Seo } from "components/Seo";

const options: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};

const Products = () => {
  const params = useParams();
  const [products, setProducts] = useState<Activeproduct[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const getProducts = async () => {
      const productResponse = await companyService.getCompanyProducts(params.id as string);
      setProducts(productResponse?.activeProducts as Activeproduct[]);
    };
    getProducts().then(()=>{
      setLoading(false);
    });
  }, [params.id]);

 

  if(loading)
  {
    return (<LoadingScreen/>) 
  }

  return (<><Seo title="Mine produkter" />
    <div className="card">
      <div className="card-body">
        <h1 className="h3">Produkter</h1>
        <table className="table cc-table-2-col">
          <tbody>
            <tr>
              <th>Produkt</th>
              <th>Periode</th>
            </tr>
            {products?.map((_item, _index) => (
              <tr key={_index}>
                <td>{_item.productName}</td>
                <td>
                  {new Date(_item.startDate).toLocaleDateString(
                    "no-NB",
                    options
                  )}{" "}
                  -{" "}
                  {new Date(_item.endDate).toLocaleDateString("no-NB", options)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p>
          <a href="https://kundeservice.1881.no/hc/no/articles/19307392067229-Kontakt-oss-Bedrift">Kontakt kundeservice for endringer</a>
        </p>
        <p className="mt-4 mb-0">
        <Link to={`${UrlPath.MyAccount.Home}/`} className="btn btn-outline-primary"><i className="bi bi-arrow-left"></i> Tilbake</Link>
        </p>
      </div>
    </div>
  </>);
};

export default Products;
